import SettingsMFAPage from "./SettingsMFAPage";

export default SettingsMFAPage;
